<template>
  <permissions-view
    :site="site"
    :section="section"
  >
    <v-container>
      <v-form
        v-model="valid"
        ref="form"
      >
        <v-row>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              label="Address"
              :value="getValue(contract, 'address')"
              @input="setValue(contract, 'address', $event)"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <town
              :readonly="isReadOnly()"
              label="Town"
              :value="getValue(contract, 'town_id')"
              @input="setValue(contract, 'town_id', $event)"
            ></town>
          </v-col>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              label="Land registry"
              :value="getValue(contract, 'land_registry')"
              @input="setValue(contract, 'land_registry', $event)"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              label="Cadastral parcel"
              :value="getValue(contract, 'cadastral_parcel')"
              @input="setValue(contract, 'cadastral_parcel', $event)"
            ></text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              label="Cadastral municipality"
              :value="getValue(contract, 'cadastral_municipality')"
              @input="setValue(contract, 'cadastral_municipality', $event)"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Site status"
            >{{ site.status|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Site type"
            >{{ site.type|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <form-actions
          v-if="!isReadOnly()"
          :loading="loading"
          :saved="saved"
          v-on:saveData="saveData"
        />
      </v-form>
      <empty-space></empty-space>
      <h2>Contracts</h2>
      <contracts
        :site="site"
        :contract="contract"
        :auto-open="autoOpen"
      ></contracts>
    </v-container>
  </permissions-view>
</template>

<script>
  import TextField from '@/components/TextField'
  import Town from '@/components/codelist/Town'
  import DisplayField from '@/components/DisplayField'
  import Contracts from '@/views/sites/sections/contract/Contracts'
  import FileUpload from '@/components/FileUpload'
  import SiteContractService from '@/services/site-contract'
  import ReactivityMixin from '@/mixins/Reactivity'
  import ValidationMixin from '@/mixins/Validation'
  import FormActions from '@/components/FormActions'
  import EmptySpace from '@/components/EmptySpace'
  import PermissionsView from '@/components/PermissionsView'
  import PermissionsMixin from '@/mixins/Permissions'

  export default {
    name: 'Contract',
    mixins: [
      ReactivityMixin,
      ValidationMixin,
      PermissionsMixin,
    ],
    components: { PermissionsView, EmptySpace, FormActions, FileUpload, Contracts, DisplayField, Town, TextField },
    props: {
      site: {
        default: null,
      },
      active: {
        default: false,
      },
      autoOpen: {
        default: null,
      },
    },
    mounted () {
      this.fetchData()
    },
    data: () => ({
      valid: false,
      contract: {},
      loading: false,
      saved: false,
      section: 'contract',
    }),
    methods: {
      fetchData () {
        const scs = new SiteContractService(this.site.id)
        scs.getSingle().then((response) => {
          this.contract = response.data.data
          if (Array.isArray(this.location)) {
            this.contract = {}
          }
        })
      },
      saveData () {
        this.validate()
        if (this.valid) {
          this.saved = false
          this.loading = true
          const scs = new SiteContractService(this.site.id)
          scs.post(this.contract).then((response) => {
            this.saved = true
          }).finally(() => {
            this.loading = false
          })
        }
      },
    },
  }
</script>

<style scoped>

</style>
